<template>
  <li
    class="col-md-2 col-sm-3 col-3 list-inline-item mx-0 mb-20 active"
    :class="isClickable"
    @click="changeStep()"
  >
    <div class="text-center pb-icon">
      <div class="icon">
        <i :class="icon"></i>
      </div>
      <div class="my-2 check">
        <i v-html="stepStatus"></i>
      </div>
    </div>
    <p
      class="text-center"
      :class="{ 'font-weight-bold': this.isFontBold }"
      v-html="description"
    ></p>
  </li>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ProgressStep',
  props: {
    stepNumber: {
      type: Number,
      default: 1,
    },
    icon: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'order',
    },
    historyStatus: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      currentStep: 'order/currentStep',
      reachedStep: 'order/reachedStep',
    }),
    stepStatus() {
      if (
        (this.type === 'order' && this.currentStep === this.stepNumber) ||
        (this.type === 'history' && this.historyStatus === this.stepNumber)
      ) {
        return '<i class="fas fa-check-circle"></i>';
      }

      if (
        (this.type === 'order' && this.stepNumber > this.reachedStep) ||
        (this.type === 'history' && this.historyStatus < this.stepNumber)
      ) {
        return '<i class="far fa-circle"></i>';
      }

      return '<i class="far fa-check-circle"></i>';
    },
    isClickable() {
      return (this.type === 'order' && this.stepNumber > this.reachedStep) ||
        this.type === 'history'
        ? 'not-clickable'
        : '';
    },
    isFontBold() {
      return this.type === 'order' && this.currentStep === this.stepNumber;
    },
  },
  methods: {
    changeStep() {
      this.$store.commit('order/changeStep', this.stepNumber);
    },
  },
};
</script>

<style scoped>
.not-clickable {
  pointer-events: none;
}
</style>
